import createTranslator from '@/i18n/utils/createTranslator';

export const commonInt = createTranslator('common');
export const errorInt = createTranslator('common.errors');
